// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchConsoleBrandingParams = {
    catalogId: number,
    deployment: string,
    sellerId: number,
};

export default {
    fetchConsoleBranding: ({ catalogId, deployment, sellerId }: FetchConsoleBrandingParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ deployment, path: '<ITEM-API>console/branding' });
            request.send({
                catalogId,
                sellerId,
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
